import {t} from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import BaseDialogContainer from '../../baseContainers/BaseDialogContainer';
import DivContainer from '../../components/DivContainer';
import SettingService from '../../services/SettingService';
import Card from 'react-bootstrap/Card';
import {withRouter} from 'react-router-dom/cjs/react-router-dom.min';
import SurveyResultComponent from './SurveyResultComponent';
import UserQuizListContainer from './UserQuizListContainer';
import QuizDetailsResponse from './QuizDetailsResponse';
import QuizService from '../../services/QuizService';

class ResultDialog extends BaseDialogContainer {
    constructor(props) {
        super(props, new QuizService());
        this.settingService = new SettingService();
        this.state = {
            element: new QuizDetailsResponse([]),
            elementId: props.quizId,
            locales: [],
            locale: props.locale
        };
    }

    translate(key) {
        const {t} = this.props;
        return t(key);
    }
    initBeforeSetElement(){
        this.settingService
            .getSupportedLocales()
            .then((supportedLocales) => {
                this.setState({
                    supportedLocales,
                    element: new QuizDetailsResponse(supportedLocales),
                });
            })
            .catch(() => {
                this.showErrorMessage(t('error.getSupportedLocalesError'));
            });
    }
    updateElement(data) {
        const questions = data.translations[this.state.locale]?.questions;
        this.setState(
            {
                uploadedFile: data.quizIcon,
                element: QuizDetailsResponse.copy(data, this.state.supportedLocales),
                questions: questions
            },
            () => {
                this.initAfterSetElement();
            }
        );
    }
    beforeUpdateElement(viewMode, elementId, locale) {
        if (elementId) {
            this.blockUi();
            this.service
                .get(elementId, locale)
                .then((data) => {
                    this.setState({loading: false, locale}, () => this.updateElement(data));
                })
                .catch((err) => {
                    this.handleGetDetailsError(err);
                });
        } else {
            this.setState({loading: false}, this.initAfterSetElement());
        }
    }
    onKeyDown(e){
    }

    setElement() {
        const {viewMode} = this.props;
        const {elementId, locale} = this.state;
        this.beforeUpdateElement(viewMode, elementId, locale);
    }

    renderFooter() {
        const footerItems = this.prepareFooterItems();
        if (footerItems !== undefined && footerItems.length > 0 && footerItems.filter((f) => f.rendered !== false)?.length > 0) {
            return (
                <React.Fragment>
                    <hr className='line-footer-user-dialog' />
                    {this.prepareFooter(footerItems)}
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    prepareFooterItems() {
    }
    renderSurveyResults() {
        return (
            <DivContainer colClass='col-12'>
                <div>
                    <SurveyResultComponent
                        quizId={this.state.elementId}
                        questions={this.state.questions}
                    />
                </div>
            </DivContainer>
        )
    }

    renderQuizResults() {
        return (
            <DivContainer colClass='col-12'>
                <div>
                    <UserQuizListContainer 
                      quizId={this.state.elementId}
                      expandFilters={false}
                    />
                </div>
            </DivContainer>
        );
    }
    renderHeader() {
        const type= this.state.element.quizType === 'SURVEY' ? 'ankiety' : 'quizu';
        return (
            <DivContainer colClass='col-12'>
                <DivContainer colClass='col-12'>
                    <label>{`Wyniki ${type}`}</label>
                </DivContainer>
            </DivContainer>
        );
    }
    
    getContainerListName() {
        return 'user-list-container';
    }

    getAddSucces() {
        const {t} = this.props;
        return t('user.addUserSuccess');
    }
    getUpdateSucces() {
        return t('user.updateUserSuccess');
    }

    renderDetails() {
        return (
            <Card className='input-card-userdialog'>
                <div className='row'>
                {this.state.element.quizType === 'SURVEY'
                            ? this.renderSurveyResults()
                            : this.renderQuizResults()
                }
                   </div>
            </Card>
        );
    }
}

ResultDialog.defaultProps = {
    visible: false,
};

ResultDialog.propTypes = {
    visible: PropTypes.bool,
    elementId: PropTypes.number,
};

export default withRouter(withTranslation()(ResultDialog));
